<template>
  <el-dialog title="WhatsApp Notificação" center :visible.sync="dialog">
    <el-alert :closable="false">Informe os telefones celulares que você deseja receber notificação sobre a entrega dessa
      etiqueta <b>{{ tag }}</b></el-alert>
    <el-form :model="ruleForm">
      <el-row :gutter="5">
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <el-form-item :label="$t('celular')">
            <el-input ref="cellphone" v-model="ruleForm.phone" v-mask="['(##) #####-####', '(##) #####-####']">
              <el-button slot="append" type="default" @click="add()">Adicionar</el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table :data="tableList" v-loading="loading">
      <el-table-column property="phone" label="Telefone" width="150"></el-table-column>
      <el-table-column label="#">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="remove(scope.$index, scope.row)">Remover</el-button>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button @click.stop.prevent="dialog = false">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { i18n } from "@/plugin/i18n";
import { NotificationService } from "@/services/comum/notification.services";

export default {
  name: "NotificationTag",
  props: ["tag", "back"],
  data() {
    return {
      dialog: false,
      loading: false,
      ruleForm: {
        phone: '',
      },
      tableList: [],
    };
  },
  methods: {
    open() {
      const vm = this;
      if (!vm.tag) return false;
      const loading = vm.$loading(vm.$options.loading);
      NotificationService.tag(vm.tag)
        .then((response) => {
          vm.tableList = response;
          this.dialog = true;
        })
        .catch((err) => {
        })
        .finally(() => loading.close());
    },
    add() {
      const vm = this;
      if (!vm.ruleForm.phone) {
        return this.$message({
          type: "error",
          duration: 5000,
          message: "Informe o telefone celular de notificação",
        });
      }
      const loading = vm.$loading(vm.$options.loading);
      NotificationService.notification(vm.tag, vm.ruleForm.phone)
        .then((response) => {
          vm.tableList.push({
            id: response,
            phone: vm.ruleForm.phone
          });
          this.ruleForm.phone = '';
          vm.$refs.cellphone.$el.children[0].select();
        })
        .catch((err) => {
          return this.$message({
            type: "error",
            duration: 5000,
            message: err,
          });
        })
        .finally(() => loading.close());

    },
    remove(index, row) {
      const vm = this;
      if (row.id) {
        const loading = vm.$loading(vm.$options.loading);
        NotificationService.deleteTag(row.id)
          .then((response) => {
            vm.tableList = response;
            this.dialog = true;
          })
          .catch((err) => {
          })
          .finally(() => loading.close());
      }
      this.tableList.splice(index, 1);
    },
    whatsapp() {
      const vm = this;
      vm.$confirm(
        i18n.t("confirmar-notificacao-rastreio"),
        i18n.tc("aviso"),
        {
          confirmButtonText: "Sim",
          cancelButtonText: i18n.tc("nao"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        this.$message({
          type: "success",
          duration: 5000,
          message: "Notificação configurada com sucesso",
        });
      });
    },
  }
}
</script>
<style> .tag-icon {
   margin-left: 5px;
   margin-right: 5px;
 }
</style>